import { defineStore } from 'pinia'

export const useLoadingStore = defineStore({
    id: "loading",
    state: () => {
        return {
            isLoading: false,
        }
    },
    getters: {
    },
    actions: {
        // ローディング表示
        async startLoading() {
            this.isLoading = true;
        },
        // ローディング非表示
        endLoading() {
            this.isLoading = false;
        }
    },
})